export var CONSTANTS = {
  PRODUCT_STATUSES: {
    UNAVAILABLE: 0,
    AVAILABLE: 1
  },
  PRODUCT_TYPES: {
    PREORDER: 0,
    STOCK: 1,
    CATALOG: 2,
    DONATE: 3
  },
  PRODUCT_FLAGS: {
    NOOP: 0,
    SOLD_OUT: 1
  },
  SPECIAL_EVENT_TYPES: {
    BIRTHDAY: 1,
    ANNIVERSARY: 2,
    OTHER: 9999
  },
  PAGE_STATUSES: {
    PUBLISHED: 1,
    DRAFT: -1
  },
  MONTH_LIST: [
    { days: 31, value: '01', name: 'มกราคม' },
    { days: 29, value: '02', name: 'กุมภาพันธ์' },
    { days: 31, value: '03', name: 'มีนาคม' },
    { days: 30, value: '04', name: 'เมษายน' },
    { days: 31, value: '05', name: 'พฤษภาคม' },
    { days: 30, value: '06', name: 'มิถุนายน' },
    { days: 31, value: '07', name: 'กรกฎาคม' },
    { days: 31, value: '08', name: 'สิงหาคม' },
    { days: 30, value: '09', name: 'กันยายน' },
    { days: 31, value: '10', name: 'ตุลาคม' },
    { days: 30, value: '11', name: 'พฤศจิกายน' },
    { days: 31, value: '12', name: 'ธันวาคม' }
  ]
}

export default {
  install (Vue, options) {
    Vue.prototype.$const = CONSTANTS
  }
}



// WEBPACK FOOTER //
// ./src/constants.js